// PROD backend: "https://cessnock-life-backend.fly.dev/"
// DEV backend: "http://localhost:5000/"

let CONSTANTS = {
	backend: "https://cessnock-life-backend.fly.dev/",
};

export default CONSTANTS;
